// extracted by mini-css-extract-plugin
export var dot = "_q0-2";
export var wave = "_q0-0";
export var waveSmall = "_q0-1";